var _path, _path2, _path3, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPopLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 903,
    height: 1131,
    viewBox: "0 0 903 1131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-254.068 673.953C-245.382 708.256 -221.074 736.916 -184.471 759.36C-147.866 781.806 -98.9922 798.015 -41.2516 807.41C74.2279 826.2 225.077 817.723 383.913 777.5C542.749 737.277 679.452 672.937 772.07 601.45C818.38 565.705 853.648 528.189 875.159 491.027C896.667 453.867 904.405 417.091 895.718 382.789C887.032 348.486 862.724 319.825 826.121 297.381C789.516 274.936 740.642 258.727 682.902 249.332C567.422 230.542 416.573 239.019 257.737 279.242C98.9012 319.465 -37.8016 383.805 -130.42 455.292C-176.729 491.037 -211.998 528.553 -233.508 565.715C-255.017 602.875 -262.755 639.651 -254.068 673.953Z",
    stroke: "url(#paint0_linear_915_472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-514.675 739.947C-502.035 789.86 -466.669 831.545 -413.454 864.176C-360.236 896.808 -289.195 920.365 -205.284 934.019C-37.4627 961.326 181.742 949.004 412.543 890.558C643.344 832.111 841.994 738.618 976.591 634.729C1043.89 582.783 1095.16 528.254 1126.43 474.226C1157.7 420.2 1168.96 366.707 1156.33 316.794C1143.69 266.882 1108.32 225.197 1055.1 192.566C1001.89 159.934 930.846 136.377 846.934 122.723C679.113 95.4156 459.908 107.738 229.107 166.184C-1.69323 224.631 -200.343 318.123 -334.941 422.013C-402.24 473.959 -453.507 528.488 -484.779 582.516C-516.05 636.541 -527.314 690.035 -514.675 739.947Z",
    stroke: "url(#paint1_linear_915_472)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-689.837 820.123C-672.388 889.03 -623.566 946.564 -550.136 991.589C-476.704 1036.62 -378.69 1069.12 -262.933 1087.95C-31.4226 1125.62 270.959 1108.62 589.327 1028C907.695 947.379 1181.72 818.413 1367.4 675.096C1460.24 603.437 1530.97 528.205 1574.13 453.655C1617.28 379.107 1632.83 305.272 1615.38 236.365C1597.93 167.457 1549.11 109.924 1475.68 64.8983C1402.25 19.871 1304.23 -12.6282 1188.48 -31.4636C956.966 -69.1342 654.585 -52.1346 336.217 28.4868C17.8487 109.108 -256.179 238.075 -441.858 381.392C-534.698 453.051 -605.431 528.283 -648.582 602.833C-691.732 677.38 -707.287 751.216 -689.837 820.123Z",
    stroke: "url(#paint2_linear_915_472)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_915_472)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 964.453,
    y: 771.056,
    width: 271.645,
    height: 298.383,
    rx: 135.823,
    transform: "rotate(145.17 964.453 771.056)",
    fill: "url(#paint3_linear_915_472)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_915_472)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1106.43,
    y: 909.744,
    width: 473.293,
    height: 519.879,
    rx: 236.647,
    transform: "rotate(145.17 1106.43 909.744)",
    fill: "url(#paint4_linear_915_472)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_915_472",
    x: 424.283,
    y: 379.357,
    width: 686.94,
    height: 693.617,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_915_472"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_915_472",
    x: 313.744,
    y: 375.743,
    width: 899.942,
    height: 911.575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_915_472"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_915_472",
    x1: 855.901,
    y1: 362.923,
    x2: -140.158,
    y2: 776.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_915_472",
    x1: 1098.25,
    y1: 287.986,
    x2: -348.951,
    y2: 888.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_915_472",
    x1: 1535.1,
    y1: 196.676,
    x2: -461.068,
    y2: 1024.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491388,
    stopColor: "#484848",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_915_472",
    x1: 1243.42,
    y1: 995.694,
    x2: 901.393,
    y2: 1098.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A059FD",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_915_472",
    x1: 1592.48,
    y1: 1301.14,
    x2: 996.558,
    y2: 1479.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25F5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3A3F",
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopLight);
export default __webpack_public_path__ + "static/media/popLight.1021cc16e8bd4a469c7b8fbbb3f365a9.svg";
export { ForwardRef as ReactComponent };